/*
 * Copyright (c) 2017 by Julian Feder, julian.feder@yahoo.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('board.dinghy.event.detail.notes', {
            parent: 'board.dinghy.event.detail',
            url: '/notes',
            data: {
                authorities: ['ROLE_DINGHY', 'ROLE_BOARD'],
                pageTitle: 'askApp.dinghyEvent.detail.notesTitle'
            },
            views: {
                'dinghyDetail@board.dinghy.event.detail': {
                    templateUrl: 'app/board/dinghy/event/detail/notes/dinghy-event-notes.html',
                    controller: 'DinghyEventNotesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dinghy');
                    $translatePartialLoader.addPart('dinghyEvent');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
